const novaTheme = {
  theme_mode: "light",
  page_background: "#F9F4F0",
  card_background: "#FFFFFF",
  primary_color: "#202F59",
  secondary_color: "#DC834E",
  accent_background: "#B783FC",
  success_background: "#42A91E",
  error_background: "#C62A29",
  h1_color: "#000000",
  h2_color: "#DC834E",
  h3_color: "#000000",
  h4_color: "#828282",
  body_text_color: "#828282",
  small_text_color: "#828282",
  link_text_color: "#000000",
  primary_text_color: "#FFFFFF",
  secondary_text_color: "#FFFFFF",
  accent_text_color: "#FFFFFF",
  font_name: "Mulish",
  font_link:
    "https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
};

const sunsetBlazeTheme = {
  theme_mode: "light",
  page_background: "#FFF7F0",
  card_background: "#FFFFFF",
  primary_color: "#B12A5B",
  secondary_color: "#FF9505",
  accent_background: "#FF5E5B",
  success_background: "#45BF55",
  error_background: "#D7263D",
  h1_color: "#1C1C1C",
  h2_color: "#FF9505",
  h3_color: "#333333",
  h4_color: "#777777",
  body_text_color: "#555555",
  small_text_color: "#999999",
  link_text_color: "#B12A5B",
  primary_text_color: "#FFFFFF",
  secondary_text_color: "#FFFFFF",
  accent_text_color: "#FFFFFF",
  font_name: "Mulish",
  font_link:
    "https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
};

const oceanDepthsTheme = {
  theme_mode: "light",
  page_background: "#E6F4F1",
  card_background: "#FFFFFF",
  primary_color: "#005377",
  secondary_color: "#00A6A6",
  accent_background: "#1BA098",
  success_background: "#3FA34D",
  error_background: "#D72638",
  h1_color: "#002F36",
  h2_color: "#00A6A6",
  h3_color: "#003B46",
  h4_color: "#406E8E",
  body_text_color: "#4A707A",
  small_text_color: "#678D99",
  link_text_color: "#005377",
  primary_text_color: "#FFFFFF",
  secondary_text_color: "#FFFFFF",
  accent_text_color: "#FFFFFF",
};

const forestBreezeTheme = {
  theme_mode: "light",
  page_background: "#F0F5F0",
  card_background: "#FFFFFF",
  primary_color: "#1E5631",
  secondary_color: "#A4DE02",
  accent_background: "#415E72",
  success_background: "#4CAF50",
  error_background: "#C0392B",
  h1_color: "#142F1A",
  h2_color: "#A4DE02",
  h3_color: "#274E13",
  h4_color: "#6C8E58",
  body_text_color: "#4B6043",
  small_text_color: "#7C9771",
  link_text_color: "#1E5631",
  primary_text_color: "#FFFFFF",
  secondary_text_color: "#000000",
  accent_text_color: "#FFFFFF",
  font_name: "Mulish",
  font_link:
    "https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
};

const indigoIceTheme = {
  theme_mode: "light",
  page_background: "#F2F4FA",
  card_background: "#FFFFFF",
  primary_color: "#3F51B5",
  secondary_color: "#00BCD4",
  accent_background: "#9FA8DA",
  success_background: "#4CAF50",
  error_background: "#F44336",
  h1_color: "#1A237E",
  h2_color: "#00ACC1",
  h3_color: "#303F9F",
  h4_color: "#7986CB",
  body_text_color: "#3E4C59",
  small_text_color: "#8A94A6",
  link_text_color: "#3F51B5",
  primary_text_color: "#FFFFFF",
  secondary_text_color: "#FFFFFF",
  accent_text_color: "#FFFFFF",
  font_name: "Mulish",
  font_link:
    "https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
};

export {
  novaTheme,
  sunsetBlazeTheme,
  oceanDepthsTheme,
  forestBreezeTheme,
  indigoIceTheme,
};
